<template>
  <Modal
    name="creditCardModal"
    @opened="handleOpenedModal"
    @closed="handleClosedModal"
  >
    <div v-if="isModalOpened" :class="$style.wrapper">
      <img
        :class="$style.icon"
        width="50"
        height="50"
        src="@front/common/assets/Billet_2.svg"
      />

      <Typography :variant="TYPOGRAPHY_TYPES.h5" tag="h5" :class="$style.title">
        {{ $i18n('Mise à jour de votre carte de paiement') }}
      </Typography>

      <Typography>
        {{
          $i18n(
            'Mettez à jour vos informations de carte de crédit ci-dessous pour continuer à bénéficier de nos services sans interruption.',
          )
        }}
      </Typography>

      <CardForm
        :error="errorMessage"
        :class="$style.cardForm"
        :is-loading="isLoading"
        @submit="validate"
      />

      <div :class="$style.buttons">
        <Button
          appearance="link"
          @click="$store.dispatch('modal/close', 'creditCardModal')"
        >
          Annuler
        </Button>
      </div>
    </div>
  </Modal>
</template>

<script>
import { FAILURE, SUCCESS } from '@front/common/constants'
import { Button, Modal, Typography, TYPOGRAPHY_TYPES } from '@front/ui'
import useAlert from '@front/ui/Alert/useAlert'
import { defineComponent, ref } from '@vue/composition-api'
import { useStore } from '@vueblocks/vue-use-vuex'

import CardForm from '@member-area/components/CardForm.vue'
import useCustomer from '@member-area/core/resources/Customer/Customer.hook'
import useNextOrders from '@member-area/core/resources/NextOrder/NextOrder.hook'
import usePaymentMethod from '@member-area/core/resources/PaymentMethod/PaymentMethod.hook'

export default defineComponent({
  components: { Modal, CardForm, Button, Typography },
  setup() {
    const store = useStore()
    const { fetchCustomer, resubscribeCustomer } = useCustomer()
    const { addPaymentMethod } = usePaymentMethod()
    const { triggerAlert } = useAlert()
    const { fetchNextOrders } = useNextOrders()

    const isLoading = ref(false)
    const isModalOpened = ref(false)
    const errorMessage = ref()

    async function validate(card, stripe) {
      isLoading.value = true

      try {
        await addPaymentMethod({ cardNumber: card, stripe })

        try {
          await resubscribeCustomer()
          await Promise.all([fetchCustomer(), fetchNextOrders()])

          isLoading.value = false
          errorMessage.value = null

          triggerAlert({
            status: SUCCESS,
            message: 'Votre carte a bien été mise à jour',
          })
          store.dispatch('modal/close', 'creditCardModal')
        } catch {
          triggerAlert({
            status: FAILURE,
            message:
              'Nous avons rencontré un problème pour réactiver votre abonnement.',
          })
          isLoading.value = false
        }
      } catch ({ message }) {
        errorMessage.value = message

        isLoading.value = false
      }
    }

    function handleOpenedModal() {
      isModalOpened.value = true
    }

    function handleClosedModal() {
      isModalOpened.value = false
    }

    return {
      isLoading,
      errorMessage,
      validate,
      TYPOGRAPHY_TYPES,
      handleOpenedModal,
      handleClosedModal,
      isModalOpened,
    }
  },
})
</script>

<style lang="scss" module>
.wrapper {
  display: flex;
  flex-direction: column;
}

.buttons {
  display: flex;
  margin: 0px auto;
  margin-top: $ds-spacing-xs;
  gap: $ds-spacing-md;
}

.title {
  margin: $ds-spacing-md 0px;
}

.cardForm {
  margin: $ds-spacing-md 0px;
}
</style>
